import { render, staticRenderFns } from "./SalonTutoriaPreasignacion.vue?vue&type=template&id=dbf59614&"
import script from "./SalonTutoriaPreasignacion.vue?vue&type=script&lang=js&"
export * from "./SalonTutoriaPreasignacion.vue?vue&type=script&lang=js&"
import style0 from "./SalonTutoriaPreasignacion.vue?vue&type=style&index=0&id=dbf59614&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports